import React, { useEffect, useState } from "react";
import { FIRESTORE_PROXY_URL } from "../config";
import "../styles/ActivityLogs.css";

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        console.error("❌ لا يوجد رمز مصادقة، الرجاء تسجيل الدخول.");
        setLoading(false);
        return;
      }

      try {
        // ✅ جلب البيانات من Firestore عبر Cloudflare Proxy
        const response = await fetch(`${FIRESTORE_PROXY_URL}/ActivityLogs`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authToken}`,
          },
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error?.message || "❌ خطأ في جلب السجلات.");
        }

        if (data) {
          // 🔹 ترتيب السجلات تنازليًا حسب `timestamp`
          const sortedLogs = data.sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));
          setLogs(sortedLogs);
        }
      } catch (error) {
        console.error("❌ خطأ أثناء جلب سجلات النشاط:", error);
      }
      setLoading(false);
    };

    fetchLogs();
  }, []);

  return (
    <div className="logs-container">
      <h2>📜 سجل النشاط</h2>

      {loading ? (
        <p>⏳ جارٍ تحميل السجلات...</p>
      ) : logs.length === 0 ? (
        <p>📭 لا توجد أنشطة مسجلة حتى الآن.</p>
      ) : (
        <table className="logs-table">
          <thead>
            <tr>
              <th>📧 البريد الإلكتروني</th>
              <th>🎯 الإجراء</th>
              <th>⏰ الوقت</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log, index) => (
              <tr key={index}>
                <td>{log.email}</td>
                <td>{log.action}</td>
                <td>{log.timestamp ? new Date(log.timestamp.seconds * 1000).toLocaleString() : "غير متاح"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ActivityLogs;
